/** @format */

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { HomrGTGTContent } from '@shared/data-access/interfaces';

export const selectHomrState = createFeatureSelector<any>('homr');

export const selectHomrScheduleContent = createSelector(
	selectHomrState,
	(state) => state.homrScheduleContent
);

export const selectHomrGTGTContent = createSelector(
	selectHomrState,
	(state) => state.homrGTGTContent as HomrGTGTContent
);
